import { render } from "./GkTextSheet.vue?vue&type=template&id=6dec1f55&scoped=true"
import script from "./GkTextSheet.vue?vue&type=script&lang=js"
export * from "./GkTextSheet.vue?vue&type=script&lang=js"

import "./GkTextSheet.vue?vue&type=style&index=0&id=6dec1f55&scoped=true&lang=css"

import exportComponent from "/home/runner/work/estate-boost-frontend/estate-boost-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6dec1f55"]])

export default __exports__